import { IMapGeoObject } from '@cian/frontend-newbuilding-map-component';
import { ICoordinates } from '../geo';
import { TRegularInfrastructureItem } from './infrastructureItem';
import { TRegularInfrastructureType } from './infrastructureTypes';
import { TTAInfrastructureItem } from './transportAccessibilityService';

export type TRegularInfrastructureItemType =
  /** Кафе */
  | 'cafe'
  /** Поликлиники **/
  | 'clinic'
  /** Продуктовые магазины **/
  | 'grocery'
  /** Метро **/
  | 'metro'
  /** Детские сады **/
  | 'nursery'
  /** Школы **/
  | 'school';

export interface IRegularInfrastructureItem {
  /** Координаты пина на карте **/
  coordinates: ICoordinates;
  /** id **/
  id: string;
  /** Время пешком до объекта **/
  timeWalk?: number;
  /** Название объекта **/
  title: string;
  /** Тип объекта инфраструктуры **/
  type: TRegularInfrastructureItemType;
  /** Дистанция */
  distance: string;
  /** Адрес */
  address?: string | null;
}

export enum EInfrastructureView {
  ExistingObject = 'existingObject',
  FutureObject = 'futureObject',
}

export interface IRegularInfrastructureData {
  geoObjectsData: Array<{
    geoObject: IMapGeoObject;
    infrastructureItem: TRegularInfrastructureItem | null;
  }>;
  futureTypes: TRegularInfrastructureType[];
}

export interface ITAInfrastructureData {
  geoObjectsData: Array<{
    geoObject: IMapGeoObject;
    infrastructureItem: TTAInfrastructureItem | null;
  }>;
}
